import { render, staticRenderFns } from "./ConfirmForgotPasswordDialog.vue?vue&type=template&id=fd904da8&"
import script from "./ConfirmForgotPasswordDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmForgotPasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports